import { connect } from 'react-redux'
import React from 'react'
import { setNavBarProps } from 'store/navbar'
import { modalActions } from 'store/modal'
import { Loader } from 'components/UIElements'
import { USER_SCOPES } from 'utils/constants'
import { getUserRoleByStudy, getUserScopeByStudy, hasPiiRole, disableScope } from 'utils/misc'
import CreateCohortPage from '../components/CreateCohortPage'
import { actions } from '../modules/cohort'
import { getStudyVersionID, isVersionUatOrLive } from '../../../../../../../../../utils/studyConfigUtils'

const mapState = state => {
  const { user, study, studyLock, location } = state
  const studyVersionID = getStudyVersionID(location)
  const studyID = study.currentStudy.id
  const userScope = getUserScopeByStudy(user, study.currentStudy)
  const currentUserRole = getUserRoleByStudy(user, studyID)
  const { studyVersionList } = study

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    ...state.cohort.cohort,
    canWriteCohort: userScope.includes(USER_SCOPES.wxc.code),
    canAddPtp: userScope.includes(USER_SCOPES.wp.code),
    checkedPtps: state.participants.checkedPtps,
    disableTrackCreation: disableScope({ study, user, scope: USER_SCOPES.wxc.code }),
    isCreate: state.location.pathname.includes('create'),
    loading: state.loading.general,
    studyID,
    studyLock,
    hasPiiRole: hasPiiRole(currentUserRole),
    isReadOnlyState,
    studyVersionID,
  }
}

const mapActions = Object.assign({}, actions, {
  setNavBarProps,
  resetCheckedPtps: require('../../ParticipantsPage/modules/Participants').actions.resetCheckedPtps,
  ...modalActions,
})

export default connect(
  mapState,
  mapActions,
)(props => {
  if (props.loading) return <Loader />
  return <CreateCohortPage {...props} />
})
